import { login, logout, switchRole, changeKindergarten, loginWx } from '@/api/token'
import { setUserInfo, removeUserInfo, getUserInfo } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import aes from '@/utils/aes.js'

const state = {
  token: '',
  userInfo: null,
  isSetRoutes: false
}

// {"success":true,"code":200,"msg":null,"data":{"id":119,"realName":"测试教师1","nickName":"测试教师1","phone":"11111111111","password":null,"salt":null,"roleId":3,"educationGroupId":1,"kindergartenId":1,"classId":1,"sex":1,"email":"","idNum":null,"photoOssResourceId":null,"currentPoints":1001,"usedPoints":0,"earnedPoints":1,"createTime":"2018-08-29 16:57:59","createUserId":null,"updateTime":"2019-03-07 14:00:53","updateUserId":1,"status":1,"educationGroupName":"测试集团","kindergartenName":"测试幼儿园","className":"测试班","roles":[1,2,3,4,5],"token":"119_49e88b3705bf4acdb26dd40d5429ca54","photoUrl":null,"workCount":null}}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ISSETROUTES: (state, isSetRoutes) => {
    state.isSetRoutes = isSetRoutes
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { phone, password, platform } = userInfo
    return new Promise((resolve, reject) => {
      login({ phone: phone.trim(), password: aes.encrypt(password), platform: platform }).then(response => {
        if (response && response.msg && response.msg === 'Need Reset Password') {
          reject(new Error(response.msg))
        }
        const { data } = response
        if (!data) {
          reject(new Error('验证失败，请重新登录。'))
        }
        commit('SET_USERINFO', data)
        commit('SET_TOKEN', data.token)
        setUserInfo(data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 配合登录权限设置，改变issetroutes
  issetroutesChange ({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit('SET_ISSETROUTES', true)
      const { roleId } = getUserInfo()
      resolve(roleId)
    })
  },
  // 用户退出
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', {})
        commit('SET_ISSETROUTES', false)
        removeUserInfo()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', {})
      commit('SET_ISSETROUTES', false)
      removeUserInfo()
      resolve()
    })
  },
  // 访问权限接口 api/token/switchRole
  switchRole ({ commit }, role) {
    return new Promise((resolve, reject) => {
      switchRole(role).then(response => {
        if (response.code === 200) {
          const { data } = response
          if (!data) {
            reject(new Error('验证失败，请重新登录。'))
          }
          commit('SET_TOKEN', data.token)
          commit('SET_USERINFO', data)
          setUserInfo(data)
          resolve(data)
        } else {
          reject(new Error('切换角色失败'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 访问权限接口 api/token/changeKindergarten
  changeKindergarten ({ commit }, kindergartenId) {
    return new Promise((resolve, reject) => {
      changeKindergarten(kindergartenId).then(response => {
        if (response.code === 200) {
          const { data } = response
          commit('SET_TOKEN', data.token)
          commit('SET_USERINFO', data)
          setUserInfo(data)
          resolve(data)
        } else {
          reject(new Error('切换幼儿园失败'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 权限路由重置
  rolesChange ({ dispatch }, role) {
    return new Promise(async resolve => {
      const data = await dispatch('switchRole', role)
      const roleId = [data.roleId]
      resetRouter()
      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roleId, { root: true })
      // dynamically add accessible routes
      router.addRoutes(accessRoutes)
      // // reset visited views and cached views
      // dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  },
  loginWx ({ commit }, params) {
    const { appId, code, encryptedData, iv, kindergartenId, introducerId } = params
    return new Promise((resolve, reject) => {
      var param = introducerId ? { appId: appId, code: code, encryptedData: encryptedData, iv: iv, kindergartenId: kindergartenId, introducerId: introducerId } : { appId: appId, code: code, encryptedData: encryptedData, iv: iv, kindergartenId: kindergartenId }
      loginWx(param).then(response => {
        const { data } = response
        if (!data) {
          reject(new Error('验证失败，请重新登录。'))
        }
        commit('SET_USERINFO', data)
        commit('SET_TOKEN', data.token)
        setUserInfo(data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js